import React, { useRef, useEffect } from 'react';
import './ProjectVideos.css';
import playIcon from '../../../Assets/play-icon.svg';

function ProjectVideos() {
  const carouselRef = useRef(null);
  const autoScrollIntervalRef = useRef(null);

  const videoData = [
    {
      id: 1,
      instagramUrl: "https://instagram.com/p/DPqILTeESKQ"
    },
    {
      id: 2,
      instagramUrl: "https://instagram.com/p/DPs-5iDEd4h"
    },
    {
      id: 3,
      instagramUrl: "https://instagram.com/p/DPvGaqsEjkx"
    },
    {
      id: 4,
      instagramUrl: "https://instagram.com/p/DP0wSM6kZTE"
    }
  ];

  const scroll = (direction) => {
    if (carouselRef.current) {
      const scrollAmount = 340; // card width + gap
      const scrollPos = carouselRef.current.scrollLeft + (direction * scrollAmount);
      const maxScroll = carouselRef.current.scrollWidth - carouselRef.current.clientWidth;
      
      // If we're at the end, loop back to start
      if (scrollPos > maxScroll) {
        carouselRef.current.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } 
      // If we're at the start and going backwards, go to end
      else if (scrollPos < 0) {
        carouselRef.current.scrollTo({
          left: maxScroll,
          behavior: 'smooth'
        });
      }
      // Normal scroll
      else {
        carouselRef.current.scrollTo({
          left: scrollPos,
          behavior: 'smooth'
        });
      }
    }
  };

  // Auto-scroll functionality
  useEffect(() => {
    let isComponentMounted = true;

    const startAutoScroll = () => {
      if (isComponentMounted) {
        autoScrollIntervalRef.current = setInterval(() => {
          scroll(1);
        }, 4000); // Scroll every 4 seconds
      }
    };

    const stopAutoScroll = () => {
      if (autoScrollIntervalRef.current) {
        clearInterval(autoScrollIntervalRef.current);
        autoScrollIntervalRef.current = null;
      }
    };

    // Start auto-scroll
    startAutoScroll();

    // Stop auto-scroll when user interacts with carousel
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener('mouseenter', stopAutoScroll);
      carousel.addEventListener('mouseleave', startAutoScroll);
      carousel.addEventListener('touchstart', stopAutoScroll);
      carousel.addEventListener('touchend', startAutoScroll);
    }

    // Cleanup function
    return () => {
      isComponentMounted = false;
      stopAutoScroll();
      if (carousel) {
        // Remove event listeners
        carousel.removeEventListener('mouseenter', stopAutoScroll);
        carousel.removeEventListener('mouseleave', startAutoScroll);
        carousel.removeEventListener('touchstart', stopAutoScroll);
        carousel.removeEventListener('touchend', startAutoScroll);
      }
    };
  }, []);

  return (
    <section className="project-videos">
      <div className="project-videos-container">
        {/* Left Content */}
        <div className="project-videos-content">
          <h2>Explore Our Recent Work</h2>
          <p>Watch our real construction projects and home builds come to life.</p>
          <button className="view-more-btn">
            View More Videos
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h14m-7-7l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Right Video Grid/Carousel */}
        <div className="video-carousel-wrapper">
          <button 
            className="carousel-nav prev" 
            onClick={() => scroll(-1)}
            aria-label="Previous videos"
          >‹</button>

          <div className="video-carousel" ref={carouselRef}>
            {videoData.map((video) => (
              <div key={video.id} className="video-card">
                <div className="video-thumbnail">
                  <iframe
                    className="instagram-reel"
                    src={`${video.instagramUrl}/embed`}
                    frameBorder="0"
                    scrolling="no"
                    allowtransparency="true"
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                  ></iframe>
                </div>
              </div>
            ))}
          </div>

          <button 
            className="carousel-nav next" 
            onClick={() => scroll(1)}
            aria-label="Next videos"
          >›</button>
        </div>
      </div>
    </section>
  );
}

export default ProjectVideos;